import {useEffect} from "react"
import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import {useNavigate} from "react-router-dom"
import {Tile, Tiles} from "../../components/UI/Tiles"

const ServicesScreen = () => {
	const navigate = useNavigate()

	useEffect(() => {
		document.title = 'АТС24 — Сервисы для логистики'
	}, [])

	return (
		<ContentBlock gap={2}>
			<ContentCard title="Сервисы" size="large">
				<p className="description">
					Мы следим за тенденциями рынка логистики и регулярно запускаем современные инструменты,
					доступные сразу всем клиентам.
				</p>
			</ContentCard>
			<Tiles>
				<Tile style={{cursor: 'pointer'}} onClick={() => navigate('/services/motivation')}>
					<img
						src="/assets/img/jpg/services/motivation.jpg"/>
					<h3>Мотивация водителей</h3>
					<p style={{fontSize: '1rem'}}>
						Гибкая система автоматического учёта качества работы водителей с личными балансами и
						бонусной системой.
					</p>
				</Tile>
				<Tile style={{cursor: 'pointer'}} onClick={() => navigate('/services/fines')}>
					<img
						src="/assets/img/jpg/services/fines.jpg"/>
					<h3>Штрафы ГИБДД</h3>
					<p style={{fontSize: '1rem'}}>
						Автоматическая проверка штрафов с привязкой к водителю.
					</p>
				</Tile>
				<Tile style={{cursor: 'pointer'}} onClick={() => navigate('/services/telegram')}>
					<img
						src="/assets/img/jpg/services/telegram.jpg"/>
					<h3>Телеграм бот</h3>
					<p style={{fontSize: '1rem'}}>
						Система адресных оповещений сотрудников о важных событиях, срывах доставки, нарушений режима
						перевозки и многого другого.
					</p>
				</Tile>
				<Tile style={{cursor: 'pointer'}} onClick={() => navigate('/services/temperature')}>
					<img
						src="/assets/img/jpg/services/temperature.jpg"/>
					<h3>Контроль температуры</h3>
					<p style={{fontSize: '1rem'}}>
						Мониторинг температурного режима с уведомлением о превышении порогов.

					</p>
				</Tile>
				<Tile style={{cursor: 'pointer'}} onClick={() => navigate('/services/observers')}>
					<img
						src="/assets/img/jpg/services/observers.jpg"/>
					<h3>Кабинет клиента</h3>
					<p style={{fontSize: '1rem'}}>
						Предоставьте вашим клиентам и партнерам возможность отслеживать состояние их доставок в
						реальном времени.
					</p>
				</Tile>
				<Tile style={{cursor: 'pointer'}} onClick={() => navigate('/services/director')}>
					<img
						src="/assets/img/jpg/services/director.jpg"/>
					<h3>Руководителю</h3>
					<p style={{fontSize: '1rem'}}>
						Статистка, информация о маршрутах, точках и водителях за любой день.

					</p>
				</Tile>
			</Tiles>
		</ContentBlock>
	)
}

export default ServicesScreen